import { combineReducers } from "redux";

import userReducer from "./userReducer";
import EditReducer from "./EditReducer";

const rootReducer = combineReducers({
  user: userReducer,
  Edit: EditReducer
});

export default rootReducer;
